import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  InputLabel,
  List,
  ListItem,
  ListItemButton,
  MenuItem,
  Select,
  Stack,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import axios from "axios";
import { RECORDS_API_URL } from "../../api/urls";
import MyFormBox from "../../helpers/MyFormBox";
import PrintViewer from "../../helpers/PrintViewer";
import JobTicket from "../../forms/JobTicket";
import {
  handleApiError,
  onNUM,
  onSTR,
  onSTRCode,
} from "../../helpers/HandleChange";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";

export default function RecAW({ user }) {
  const navigate = useNavigate();
  const [DBLoading, SetDBLoading] = useState(true);
  const [artWorks, setArtWorks] = useState([]);
  const [extras, setExtras] = useState([]);
  const [selectedJob, setSelectedJob] = useState(null);
  const [selectedRec, setSelectedRec] = useState(null);
  const [allJobs, setAlJobsSearch] = useState([]);

  const makeItLoad = DBLoading;

  useEffect(() => {
    SetDBLoading(true);

    axios
      .get(`${RECORDS_API_URL}/nim/aw`)
      .then((res) => {
        setArtWorks(res.data.artworks || []);
        setAlJobsSearch(res.data.allCreatedJobs || []);
        console.log(res.data);
      })
      .catch((err) => console.error("Error fetching papers:", err))
      .finally(() => SetDBLoading(false));
  }, []);

  function AddNewAW() {
    SetDBLoading(true);
    setExtras([]);
    setSelectedJob(null);

    axios
      .post(`${RECORDS_API_URL}/nim/aw/new`, extras)
      .then((res) => setArtWorks(res.data.artworks || []))
      .catch(handleApiError)
      .finally(() => SetDBLoading(false));
  }
  function LinkJobAW() {
    SetDBLoading(true);
    setExtras([]);
    setSelectedJob(null);
    const exportz = { job_id: selectedJob?.job_id, rb_id: selectedRec?.rb_id };

    axios
      .post(`${RECORDS_API_URL}/nim/aw/link`, exportz)
      .then((res) => setArtWorks(res.data.artworks || []))
      .catch(handleApiError)
      .finally(() => SetDBLoading(false));
  }
  function UnLinkJobAW(job_id, rb_id) {
    SetDBLoading(true);
    setExtras([]);
    setSelectedJob(null);

    axios
      .post(`${RECORDS_API_URL}/nim/aw/unlink`, { job_id, rb_id })
      .then((res) => setArtWorks(res.data.artworks || []))
      .catch(handleApiError)
      .finally(() => SetDBLoading(false));
  }

  const jobFilter = (options, { inputValue }) => {
    const q = inputValue
      .toLowerCase()
      .replace(/[\s\-_()]+/g, " ")
      .trim();

    if (!q) return [];

    return options.filter((j) => {
      const hay = (
        "#" +
        jobfileTag(j?.file_id) +
        " " +
        j?.job_code +
        " " +
        j?.job_index +
        " " +
        j?.customer_name +
        " " +
        j?.cus_name_short +
        " " +
        j?.unreg_customer +
        " " +
        j?.file_name +
        " " +
        j?.doc_name +
        " " +
        j?.job_name
      )
        .toLowerCase()
        .replace(/[\s\-_()]+/g, " ")
        .trim();

      return q.split(" ").every((t) => hay.includes(t));
    });
  };

  useEffect(() => {
    console.log("idSelectedJob", selectedJob);
  }, [selectedJob]);
  useEffect(() => {
    console.log("idSelectedJob", selectedRec);
  }, [selectedRec]);

  const jobfileTag = (i) => String(i || 0).padStart(5, "0");
  const CustomerName = (j) =>
    j?.customer_id === 1
      ? j?.unreg_customer || "Unregistered"
      : j?.cus_name_short || j?.customer_name;

  // const selectedCustomer = (id) =>
  //   id ? customers.find((c) => c.id === id).customer_name : "Customer";

  return (
    <Box>
      <Backdrop sx={{ color: "#fff", zIndex: 10 }} open={makeItLoad}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <MyFormBox
        label="New ArtWork"
        buttonType="Add"
        clickable={extras?.nameid}
        user={user}
        onPress={AddNewAW}
      >
        <TextField
          size="small"
          name="nameid"
          value={extras?.nameid || ""}
          onChange={onSTRCode(setExtras)}
          label="Idenity"
          deci={0}
        />
        <Typography
          sx={{ display: "block", width: "100%", pt: 1 }}
          variant="caption"
        >
          #YYMM_0NNN {extras?.nameid ? " - " + extras?.nameid : ""}
        </Typography>
      </MyFormBox>

      <Box>
        {artWorks
          ?.slice()
          .sort((a, b) => {
            if (!a.link_to.length && b.link_to.length) return -1;
            if (a.link_to.length && !b.link_to.length) return 1;
            return a.type_id.localeCompare(b.type_id);
          })
          ?.map((aw) => (
            <Accordion
              key={aw?.rb_id}
              expanded={selectedRec?.rb_id === aw.rb_id}
              onChange={() => {
                setSelectedRec(selectedRec?.rb_id === aw?.rb_id ? null : aw);
                setExtras([]);
                setSelectedJob(null);
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreRoundedIcon />}
                sx={{
                  "&:hover": {
                    bgcolor: "#ebf2e0",
                  },
                }}
              >
                <Typography component="span" fontWeight={450}>
                  #{aw?.type_id} - {aw?.rb_data?.nameid}
                </Typography>
                {!aw?.link_to?.length && (
                  <Typography
                    fontWeight={450}
                    sx={{ color: "#a40000", ml: "auto", mr: 2 }}
                  >
                    NoLink!
                  </Typography>
                )}
              </AccordionSummary>
              <Divider />

              <AccordionDetails
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  flexWrap: "wrap",
                }}
              >
                <Autocomplete
                  sx={{
                    flex: 1,
                    minWidth: 250,
                  }}
                  options={allJobs}
                  getOptionLabel={(j) =>
                    [
                      `#${jobfileTag(j?.file_id)}_${j?.job_code || j?.job_index}`,
                      CustomerName(j),
                      j?.doc_name,
                      j?.file_name,
                      j?.job_name,
                    ]
                      .filter(Boolean)
                      .join(" - ")
                  }
                  filterOptions={jobFilter}
                  renderInput={(params) => (
                    <TextField {...params} label="Search Job" size="small" />
                  )}
                  onChange={(e, val) => setSelectedJob(val)}
                  value={selectedJob}
                />
                <Button
                  variant="outlined"
                  disabled={!selectedJob || user?.level_jobs < 1}
                  onClick={LinkJobAW}
                >
                  Link
                </Button>
                <List sx={{ width: "100%" }}>
                  {aw?.link_to?.map((li) => {
                    const j = allJobs?.find(
                      (job) => job?.job_id === Number(li),
                    );

                    if (!j) return null;

                    return (
                      <ListItem
                        key={li}
                        disablePadding
                        secondaryAction={
                          <IconButton
                            size="small"
                            onClick={() => UnLinkJobAW(li, aw?.rb_id)}
                            color="error"
                            disabled={user?.level_jobs < 1}
                          >
                            <DeleteRoundedIcon fontSize="small" />
                          </IconButton>
                        }
                      >
                        <ListItemButton
                          component={Link}
                          to={`/jobs/job/${j?.file_id}/${j?.job_index}`}
                        >
                          {[
                            `#${jobfileTag(j?.file_id)}_${j?.job_code || j?.job_index}`,
                            CustomerName(j),
                            j?.doc_name,
                            j?.file_name,
                            j?.job_name,
                          ]
                            .filter(Boolean)
                            .join(" - ")}
                        </ListItemButton>
                      </ListItem>
                    );
                  })}
                </List>
                {!!aw?.link_to?.length && (
                  <MyFormBox
                    clickable={user?.level_jobs >= 1}
                    user={user}
                    sx={{ width: "100%" }}
                  >
                    <TextField
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      size="small"
                      name="started_at"
                      value={extras?.started_at || ""}
                      onChange={onSTR(setExtras)}
                      label="Start"
                      deci={0}
                    />
                    <TextField
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      size="small"
                      name="finished_at"
                      value={extras?.finished_at || ""}
                      onChange={onSTR(setExtras)}
                      label="End"
                      deci={0}
                    />
                    <TextField
                      size="small"
                      name="drive"
                      value={extras?.drive || ""}
                      onChange={onSTR(setExtras)}
                      label="Drive Link"
                      deci={0}
                    />
                    <FormControlLabel
                      label="Performance Bond"
                      labelPlacement="Approved"
                      sx={{ ml: 0, my: 1 }}
                      control={
                        <Switch
                          checked={!!extras?.approved}
                          value={extras?.approved ? 0 : 1}
                          name="approved"
                          onChange={onNUM(setExtras)}
                          color="success"
                        />
                      }
                    />
                    <TextField
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      size="small"
                      name="approved_at"
                      value={extras?.approved_at || ""}
                      onChange={onSTR(setExtras)}
                      label="Approved"
                      deci={0}
                    />
                  </MyFormBox>
                )}
              </AccordionDetails>

              <Divider sx={{ mx: 1 }} />
            </Accordion>
          ))}
      </Box>
    </Box>
  );
}
